import React, { useState, useEffect } from 'react';
import * as S from '../styles';
import Texts from '../../Texts';
import { Box } from '@mui/material';
import TusFileUpload from '../../../helper/TusFileUpload';
import uploadIcon from '/src/assets/images/application/folder-file-up.svg?url';

interface PropsApplicationStepTow {
  publish_after_accept: boolean | null;
  onFieldChange: (field: string, value: any) => void;
}

const ApplicationEditStepTow: React.FC<PropsApplicationStepTow> = ({
  publish_after_accept,
  onFieldChange,
}) => {
  const [isPublishAfterAccept, setIsPublishAfterAccept] = useState(
    publish_after_accept === true,
  );
  const [errors, setErrors] = useState<string[]>([]);

  useEffect(() => {
    setIsPublishAfterAccept(publish_after_accept === true);
  }, [publish_after_accept]);

  const handleFileUpload = (file: File | null, fileUrl?: string) => {
    if (file && fileUrl) {
      onFieldChange('application_file', file);
      onFieldChange('application_file_url', fileUrl);
      setErrors([]);
    } else {
      onFieldChange('application_file', null);
      onFieldChange('application_file_url', null);
      setErrors(['.لطفاً یک فایل بارگذاری کنید.']);
    }
  };

  return (
    <S.Container>
      <Box
        sx={{
          // A flex row will not break a long sentence, so this line ran past
          // the card's edge. Block + full width lets it wrap normally.
          width: '100%',
          color: '#FF0000',
          fontSize: '14px',
          lineHeight: 1.8,
          textAlign: 'right',
          marginBottom: '20px',
        }}
      >
        {
          'برای ارسال مجدد فایل اپلیکیشن لازم است که ورژن یا باندل آن تغییر کرده باشد'
        }
      </Box>

      {errors.length > 0 && (
        <S.ErrorBox>
          {errors.map((error, index) => (
            <S.ErrorMessage key={index}>{error}</S.ErrorMessage>
          ))}
        </S.ErrorBox>
      )}

      <S.Form>
        <S.SubTitle2 as="div">
          {Texts.ApplicationStepTow.subTitle.split('IPA')[0]}
          <span className="blue-text">IPA</span>
          {Texts.ApplicationStepTow.subTitle.split('IPA')[1]}
        </S.SubTitle2>

        <S.FieldContainer>
          <TusFileUpload
            onFilesSelected={handleFileUpload}
            imageSrc={uploadIcon}
            width="100%"
            backgroundColor="#F0F0F0"
            uploadText={Texts.ApplicationStepTow.uploadIpa}
            acceptedFileTypes={['.ipa']}
          />
        </S.FieldContainer>
      </S.Form>
    </S.Container>
  );
};

export default ApplicationEditStepTow;
